const ITEMS = [
    "Roof Inspection",
    "Roof Installation",
    "Roof Repair",
    "Gutter Installation",
    "Gutter Repairs",
    "Roof Damage Repair",
    "Storm & Wind Damage Restoration",
    "Quality Materials For Your Building",
    "Sunyani & Nearby Areas",
];

const Row = ({ ariaHidden }) => (
    <div className="flex items-center gap-10 pr-10" aria-hidden={ariaHidden}>
        {ITEMS.map((item, i) => (
            <span key={`${i}-${item}`} className="flex items-center gap-10 shrink-0">
                <span className="font-display font-bold uppercase text-xl sm:text-3xl tracking-wide text-[#F8FAFC]/70 whitespace-nowrap">
                    {item}
                </span>
                <span className="w-2.5 h-2.5 rotate-45 bg-amber-500 shrink-0" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div
        data-testid="editorial-services-marquee"
        className="marquee relative border-y border-white/10 bg-[#13191E] py-6 overflow-hidden corrugation"
    >
        <div className="marquee-track">
            <Row ariaHidden={false} />
            <Row ariaHidden={true} />
        </div>
    </div>
);

export default Marquee;
